module.exports = __webpack_public_path__ + "img/machine_learning.c7d0a41e.svg";